export default __webpack_public_path__ + "static/media/supply.ebe503f0.svg";